import { useRef, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

export const PREVIEW_OK_KEY = "sd_preview_ok";

export function hasPreviewAccess() {
  try { return localStorage.getItem(PREVIEW_OK_KEY) === "1"; } catch { return false; }
}

export default function EmailGate({ onUnlock, headline, subhead }) {
  const [firstName, setFirstName] = useState("");
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const nameRef = useRef(null);
  const { refresh } = useAuth();

  const submit = async (e) => {
    e.preventDefault();
    if (!firstName.trim() || !email.trim()) return;
    setBusy(true);
    try {
      const { data } = await api.post("/free-preview/subscribe", {
        first_name: firstName.trim(),
        email: email.trim(),
      });
      try { localStorage.setItem(PREVIEW_OK_KEY, "1"); } catch (_) {}
      // Sign them in silently as their auto-provisioned account so practice
      // typing saves to their profile immediately.
      if (data?.token) {
        try { localStorage.setItem("sd_token", data.token); } catch (_) {}
        try { await refresh(); } catch (_) {}
      }
      toast.success("thank you. opening the chapter.");
      onUnlock?.();
    } catch (err) {
      // Never block the reader — Kit / network hiccup shouldn't be a wall.
      try { localStorage.setItem(PREVIEW_OK_KEY, "1"); } catch (_) {}
      toast.success("opening the chapter.");
      onUnlock?.();
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-lg mx-auto py-10" data-testid="email-gate">
      <p className="text-xs uppercase tracking-[0.3em] mb-4" style={{ color: "var(--gold)" }}>
        the free chapter
      </p>
      <h1 className="font-serif text-4xl sm:text-5xl mb-6" style={{ color: "var(--ink)" }} data-testid="gate-headline">
        {headline || "before you read."}
      </h1>
      <p className="mb-8" style={{ color: "var(--ink-soft)" }} data-testid="gate-subhead">
        {subhead ||
          "leave your name and email and i'll open chapter 02. both the essay and the practice. no spam. just the workshop."}
      </p>
      <form onSubmit={submit} className="space-y-6" data-testid="gate-form">
        <div>
          <label className="text-xs uppercase tracking-widest" style={{ color: "var(--ink-soft)" }}>
            first name
          </label>
          <input
            ref={nameRef}
            required
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            className="field"
            data-testid="gate-first-name"
          />
        </div>
        <div>
          <label className="text-xs uppercase tracking-widest" style={{ color: "var(--ink-soft)" }}>
            email
          </label>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="field"
            data-testid="gate-email"
          />
        </div>
        <button disabled={busy} className="btn-primary w-full" data-testid="gate-submit">
          {busy ? "opening..." : "send me the free chapter"}
        </button>
      </form>
      <p className="text-xs mt-6" style={{ color: "var(--ink-soft)" }}>
        one email. two lessons. you can close this tab and come back later. the chapter stays open.
      </p>
    </div>
  );
}
